module.exports = __webpack_public_path__ + "img/icon-badge.0c90095c.svg";